import React from 'react';

import ModalConfirm from '@/components/Modal/confirm';
import UIModal, { UIModalProps } from '../UIModal';

import './style.scss';

export type ConfirmModalProps = UIModalProps & {
  onClose?: () => void;
};

const ConfirmModal = (props: ConfirmModalProps) => {
  const { title, content, footer, onFooterClick, onMaskClick, className, onClose } = props;

  return (
    <UIModal
      title={title}
      footer={footer}
      content={content}
      className={className}
      onMaskClick={onMaskClick}
      onFooterClick={selectValue => {
        onFooterClick?.(selectValue);
        onClose?.();
      }}
    />
  );
};

export default function confirm(props: ConfirmModalProps) {
  // eslint-disable-next-line prefer-const
  let modalInstance: ReturnType<typeof ModalConfirm>;

  const mergeProps = {
    ...props,
    onClose() {
      modalInstance.destroy();
    },
  };

  // open modal
  modalInstance = ModalConfirm({ children: <ConfirmModal {...mergeProps} /> });

  return modalInstance;
}
